<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_v"></a><strong>Contents</strong></p>
<p class="toc"><a href="#/html/9780226217062_05_pt1#pt1"><strong>Part 1. Introduction</strong></a></p>
<p class="tocb"><a href="#/html/9780226217062_06_ch1#ch1">1. The Economic Approach to Human Behavior</a></p>
<p class="toc"><a href="#/html/9780226217062_07_pt2#pt2"><strong>Part 2. Price and Prejudice</strong></a></p>
<p class="tocb"><a href="#/html/9780226217062_08_ch2#ch2">2. Effective Discrimination</a></p>
<p class="toc"><a href="#/html/9780226217062_09_pt3#pt3"><strong>Part 3. Law and Politics</strong></a></p>
<p class="toc"><a href="#/html/9780226217062_10_ch3#ch3">3. Competition and Democracy</a></p>
<p class="tocb"><a href="#/html/9780226217062_11_ch4#ch4">4. Crime and Punishment: An Economic Approach</a></p>
<p class="toc"><span href="#/html/9780226217062_12_pt4#pt4" title="Link target outside of Sample"><strong>Part 4. Time and Household Production</strong></span></p>
<p class="toc"><span href="#/html/9780226217062_13_ch5#ch5" title="Link target outside of Sample">5. A Theory of the Allocation of Time</span></p>
<p class="toc"><span href="#/html/9780226217062_14_ch6#ch6" title="Link target outside of Sample">6. The Allocation of Time and Goods over Time</span></p>
<p class="tocb"><span href="#/html/9780226217062_15_ch7#ch7" title="Link target outside of Sample">7. On the New Theory of Consumer Behavior (<em>with Robert T. Michael</em>)</span></p>
<p class="toc"><span href="#/html/9780226217062_16_pt5#pt5" title="Link target outside of Sample"><strong>Part 5. Irrational Behavior</strong></span></p>
<p class="tocb"><span href="#/html/9780226217062_17_ch8#ch8" title="Link target outside of Sample">8. Irrational Behavior and Economic Theory</span></p>
<p class="toc"><span href="#/html/9780226217062_18_pt6#pt6" title="Link target outside of Sample"><strong>Part 6. Marriage, Fertility, and the Family</strong></span></p>
<p class="toc"><span href="#/html/9780226217062_19_ch9#ch9" title="Link target outside of Sample">9. An Economic Analysis of Fertility</span></p>
<p class="toc"><span href="#/html/9780226217062_20_ch10#ch10" title="Link target outside of Sample">10. On the Interaction between the Quantity and Quality of Children (<em>with H. Gregg Lewis</em>)</span></p>
<p class="tocb"><span href="#/html/9780226217062_21_ch11#ch11" title="Link target outside of Sample">11. A Theory of Marriage</span></p>
<p class="toc"><a id="page_vii"></a><span href="#/html/9780226217062_22_pt7#pt7" title="Link target outside of Sample"><strong>Part 7. Social Interactions</strong></span></p>
<p class="toc"><span href="#/html/9780226217062_23_ch12#ch12" title="Link target outside of Sample">12. A. Theory of Social Interactions</span></p>
<p class="tocb"><span href="#/html/9780226217062_24_ch13#ch13" title="Link target outside of Sample">13. Altruism, Egoism, and Genetic Fitness: Economics and Sociobiology</span></p>
<p class="toc"><span href="#/html/9780226217062_25_not#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/html/9780226217062_26_ref#ref" title="Link target outside of Sample"><em>References</em></span></p>
<p class="toc"><span href="#/html/9780226217062_27_ind#ind" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226217062_04_toc.vue?5c25285a